export default "__VITE_ASSET__BKYINlBY__"